
import { ValidationProvider } from 'vee-validate'
import Vue, { PropType } from 'vue'
import CIcon from '../c-icon/c-icon.component.vue'
import { Icon } from '../c-icon/class/icon'
import { CIconFactory } from '../c-icon/factory/c-icon.factory'
import { Checkbox } from './checkbox'

interface IData {
  /**
   * Manages the internal value of the checkbox.
   * Because of how the validation provider works, any boolean value will cause vee validate
   * to consider this to be set. Supposedly, we can set invalidateFalse to true. Did not
   * work when I tried it, but if we get more time we could try it.
   */
  newValue: boolean | undefined
}

export default Vue.extend({
  components: {
    CIcon,
    ValidationProvider
  },
  props: {
    /**
     * Boolean value for checkbox enabled/disabled status
     */
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    /**
     * Object containing properties for checkbox
     */
    properties: {
      type: Object as PropType<Checkbox>,
      required: true
    },
    /**
     * Whether the checkbox is enabled or disabled
     */
    enableCheckbox: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data(): IData {
    const newValue = this.value ? true : undefined
    return {
      newValue
    }
  },
  computed: {
    /**
     * Set Icon attributes depending on checked status
     * @todo: Will - What this hell is this. I hate this. I also wrote it. - Will
     */
    currentIcon(): Icon {
      const icon = CIconFactory.Icon({
        icon: this.checkboxValue ? this.properties.iconEnabled!.icon : this.properties.iconDisabled!.icon,
        type: this.checkboxValue ? this.properties.iconEnabled!.type : this.properties.iconDisabled!.type,
        size: this.checkboxValue ? this.properties.iconEnabled!.size : this.properties.iconDisabled!.size,
        flip: this.checkboxValue ? this.properties.iconEnabled!.flip : this.properties.iconDisabled!.flip,
        placement: this.checkboxValue ? this.properties.iconEnabled!.placement : this.properties.iconDisabled!.placement,
        alignment: this.checkboxValue ? this.properties.iconEnabled!.alignment : this.properties.iconDisabled!.alignment,
        classes: this.checkboxValue ? this.properties.iconEnabledColor! : this.properties.iconDisabledColor!
      })
      if (!this.enableCheckbox) {
        icon.classes = 'color-shades-light1-white o-50'
      }
      return icon
    },
    /**
     * Check color class name to be applied to label depending on status
     */
    textColor(): string {
      return this.checkboxValue ? this.properties.textEnabledColor! : this.properties.textDisabledColor!
    },
    /**
     * Whether the checkbox is enabled or disabled
     */
    checkboxValue: {
      get(): boolean {
        return !!this.newValue
      },
      set(value: boolean) {
        this.newValue = value ? true : undefined
        this.$emit('input', value)
      }
    }
  },

  methods: {
    /**
     * Change v-model value between true and false
     */
    toggle(): void {
      if (this.enableCheckbox) {
        this.checkboxValue = !this.checkboxValue
      }
    }
  }
})
